import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Checkbox } from "@atlaskit/checkbox";

import { PRIMARY_BLACK } from "../constants";

const wrapperStyles = css({
    "padding": "19px 16px",
    // eslint-disable-next-line local/ensure-wac-token-usage
    "border": "2px #DCDFE4 solid !important",
    "borderRadius": "8px",
    "minWidth": "400px",
    "cursor": "pointer",
    "display": "flex",
    "alignItems": "center",
    "&:hover": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        borderColor: "#0C66E4 !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label": {
        alignItems: "center",
        cursor: "pointer",
        textAlign: "left"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label span": {
        margin: "0 auto 0 4px",
        cursor: "pointer"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "input": {
        cursor: "pointer"
    }
});

const labelStyles = css({
    fontFamily: "var(--atlassian-sans-font-family)",
    fontWeight: 600,
    color: `${PRIMARY_BLACK}`,
    fontSize: "1rem",
    lineHeight: "1.2rem",
    textAlign: "left"
});

const JtbdCheckbox = ({
    name,
    id,
    isChecked,
    handleClick,
    isDisabled
}: {
    name: string;
    id: string;
    isChecked: boolean;
    handleClick: () => void;
    isDisabled: boolean;
}) => {
    const intl = useIntl();
    return (
        <label
            htmlFor={id}
            css={[
                wrapperStyles,
                // eslint-disable-next-line local/ensure-wac-token-usage
                isChecked === true && css({ borderColor: "#0C66E4 !important" })
            ]}
        >
            <Checkbox
                value={name}
                id={id}
                name={name}
                label={
                    <span css={labelStyles}>
                        {intl.formatMessage({
                            id: id,
                            defaultMessage: name
                        })}
                    </span>
                }
                isChecked={isChecked}
                isDisabled={isDisabled}
                onChange={() => {
                    handleClick();
                }}
            />
        </label>
    );
};

export default JtbdCheckbox;
